import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import App from "./App";
import { captureRqUtms } from "./utils/rqAttribution";

// Capture campaign UTMs into localStorage before React Router strips the query string.
captureRqUtms();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.error('SW registration failed:', err);
    });
  });
}